import React from 'react';
import { Redirect } from 'react-router-dom';

const Init = () => <Redirect to="/auth" />;

export default Init;
